import React, { useState, useCallback } from "react";
import { Form, Modal, Input, Select, message } from "antd";
import { STATUS, reasons, ShipmentIncompleteInitiatedBy, ShipmentIncompleteReason } from "@/utils/enum";
import { Validator } from "@/utils/validator";
import { cancelRequest } from "@/services/loads";

const { TextArea } = Input;

const CancelLoadModal = ({ visible, loadId, onClose: propOnClose }) => {
  const [formRef] = Form.useForm();

  const [status, setStatus] = useState(STATUS.IDLE);

  const onClose = useCallback(() => {
    formRef?.resetFields();

    if (typeof propOnClose === "function") {
      propOnClose();
    }
  }, [propOnClose, formRef]);

  const handleSubmitCancelLoad = useCallback(
    data => {
      setStatus(STATUS.LOADING);
      cancelRequest(loadId, data)
        .then(() => {
          setStatus(STATUS.SUCCESS);
          message.success("Successfully requested the load cancel");
          onClose();
        })
        .catch(error => {
          console.error(error);
          message.error("Failed to cancel load");
          setStatus(STATUS.ERROR);
        });
    },
    [loadId, onClose],
  );

  return (
    <Modal
      title="Cancel Load Request"
      open={visible}
      confirmLoading={status === STATUS.LOADING}
      onOk={formRef.submit}
      onCancel={onClose}
    >
      <div>Provide the reason why are you requesting to cancel this load.</div>
      <Form form={formRef} layout="vertical" onFinish={handleSubmitCancelLoad}>
        <Form.Item name="reason" label="Reason" rules={[Validator.required("Please select a reason")]}>
          <Select placeholder="Reason">
            {reasons[ShipmentIncompleteInitiatedBy.Autosled]?.map(option => (
              <Select.Option key={option.value} value={option.value}>
                {option.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item shouldUpdate={(prevValues, currentValues) => prevValues.reason !== currentValues.reason}>
          {({ getFieldValue }) => {
            const reason = getFieldValue("reason");

            return reason === ShipmentIncompleteReason.Other ? (
              <Form.Item
                name="otherReason"
                label="Other Reason"
                rules={[Validator.required("Please give another reason")]}
              >
                <TextArea rows={4} />
              </Form.Item>
            ) : null;
          }}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CancelLoadModal;
